var module = angular.module('octopusApp.certificates');
var moment = require('moment');
var truncate = require('truncate.js');

module.directive('certificateSearch', function() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'areas/certificates/select/certificate_search.html',
        scope: {
            search: '=',
            itemsPerPage: '=',
            onSelect: '=',
            archived: '=',
            appendSearchToUrl: '=',
            currentSelectedId: '=',
            isEmpty: '=',
            tenantId: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: function ($scope, busy, octopusRepository, octopusTagSets, $location, $q, $timeout, octopusPermissionSet) {
            var vm = this;

            var isLoading = vm.isLoading = busy.create();

            vm.skip = 0;
            vm.archived = !!vm.archived;
            vm.pageSelected = pageSelected;
            vm.clearSearch = clearSearch;
            vm.performSearch = performSearch;
            vm.getExpiryStatus = getExpiryStatus;
            vm.getExpiryTimeSpan = getExpiryTimeSpan;

            var expiryStatuses = {
                ok: "ok",
                warning: "warning",
                expired: "expired"
            };

            function loadCertificates() {
                var options = {};

                if (vm.search) {
                    _.extend(options, {search: vm.search});
                } else if (vm.currentSelectedId) {
                    _.extend(options, {firstResult: vm.currentSelectedId});
                }

                if (vm.tenantId) {
                    _.extend(options, {tenant: vm.tenantId});
                }

                // If we selecting a variable-value, then order by recently created
                if (vm.onSelect) {
                    _.extend(options, {orderBy: 'recent'});
                }

                var promise = octopusRepository.Certificates.list(_.extend(options, {archived: vm.archived, skip: vm.skip, take: vm.itemsPerPage})).then(function (certificates) {

                    if (certificates.Items.length === 0 && !vm.search && !vm.archived) {
                        vm.certificates = [];
                        vm.isEmpty = true;
                        return;
                    }

                    var promises = [];
                    var allEnvironments = [];
                    var allTenants = [];
                    var allTags = [];

                    promises.push(octopusRepository.Environments.all().then(function (environments) {
                        allEnvironments = environments;
                    }));

                    if (octopusRepository.Tenants) {
                        promises.push(octopusPermissionSet.isAuthorized({permission: 'TenantView'}).then(function(hasTenantView) {
                            if (hasTenantView) {
                                octopusRepository.Tenants.all().then(function (tenants) {
                                    allTenants = tenants;
                                });
                            }
                        }));

                        promises.push(octopusTagSets.getAll().then(function(tagSets) {
                            allTags = _.chain(tagSets)
                                .map(function(tagSet) {return tagSet.Tags;})
                                .flatten(true)
                                .value();
                        }));
                    }

                    return $q.all(promises).then(function() {

                        _.each(certificates.Items, function (certificate) {
                            certificate.environments = getTags(allEnvironments, certificate.EnvironmentIds);
                            certificate.tenants = getTags(allTenants, certificate.TenantIds);
                            certificate.tenantTags = _.filter(allTags, function(tag){ return _.contains(certificate.TenantTags, tag.CanonicalTagName);});
                        });

                        vm.isEmpty = false;
                        vm.certificates = certificates;
                    });
                });

                isLoading.promise(promise);
                return promise;
            }

            function getTags(allOptions, selectedOptions) {
                if (allOptions.length === 0) {
                    return "";
                }

                var result = [];

                _.each(allOptions, function (e) {
                    if (selectedOptions.indexOf(e.Id) >= 0) {
                        result.push(e.Name);
                    }
                });

                return result.join(",");
            }

            function pageSelected(skip) {
                vm.skip = skip;
                loadCertificates();
            }

            function performSearch() {
                if (!vm.searchText || vm.searchText === "") {
                    return;
                }

                if (vm.searchText !== vm.search) {
                    vm.search = vm.searchText;
                    if (vm.appendSearchToUrl) {
                        $location.search("search", vm.searchText);
                    }
                    loadCertificates();
                }
            }

            function clearSearch() {
                vm.searchText = vm.search = null;
                loadCertificates();
            }

            function getExpiryTimeSpan(certificate) {
                var now = moment();
                var certificateExpiry = moment(certificate.NotAfter);

                var prefix = certificateExpiry.isAfter(now)
                    ? "Expires "
                    : "Expired ";

                return prefix + certificateExpiry.fromNow();
            }

            function getExpiryStatus(certificate) {

                var now = moment();
                var certificateExpiry = moment(certificate.NotAfter);

                if (certificateExpiry.isBefore(now)) {
                    return expiryStatuses.expired;
                }

                if (certificateExpiry.isBefore(now.add(20, 'days'))) {
                    return expiryStatuses.warning;
                }

                return expiryStatuses.ok;
            }

            function truncateNotes() {
                var notesElements = $scope.element.find('.certificate-notes');
                var i;
                for(i = 0; i < notesElements.length; i++) {
                    // using the NPM package truncate.js, *not* the bower package jquery-truncate-html
                    new truncate.Truncate(notesElements[i], {
                        lines: 4
                    });
                }
            }

            loadCertificates().then(function() {
                $timeout(function() {
                    truncateNotes();
                });
            });
        },

        link: function($scope, $element) {
           $scope.element = $element;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/select/certificate_search.js
// module id = 1891060790245091
// module chunks = 1